import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Spinner, Badge, Alert } from "react-bootstrap";
import ModalConfirmar from "../../components/ModalConfirmar";
import * as bancosApi from "../../api/bancos";

export default function Bancos() {
  const [bancos, setBancos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [aEliminar, setAEliminar] = useState(null);
  const [form, setForm] = useState({ nombre: "", activo: true });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const cargar = async () => {
    setCargando(true);
    try { setBancos(await bancosApi.listarBancos()); }
    finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrir = (b) => {
    setError("");
    setEditando(b);
    setForm(b ? { nombre: b.nombre, activo: b.activo } : { nombre: "", activo: true });
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await bancosApi.upsertBanco({ bancoId: editando?.bancoId ?? null, nombre: form.nombre, activo: form.activo });
      setShowModal(false);
      cargar();
    } finally { setGuardando(false); }
  };

  const confirmarEliminar = async () => {
    try {
      await bancosApi.eliminarBanco(aEliminar.bancoId);
      setAEliminar(null);
      cargar();
    } catch (err) {
      setAEliminar(null);
      setError(err.response?.data?.mensaje || "No se pudo desactivar el banco.");
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Mantenimiento &gt; Bancos</h4>
        <Button size="sm" variant="primary" onClick={() => abrir(null)}><i className="bi bi-plus-lg me-1"></i>Nuevo banco</Button>
      </div>

      {error && <Alert variant="danger" dismissible onClose={() => setError("")}>{error}</Alert>}

      {cargando ? <Spinner animation="border" /> : (
        <div className="fs-card p-0 overflow-hidden">
          <Table responsive hover className="table-fs table-fs-responsive mb-0 align-middle">
            <thead><tr><th>Nombre</th><th>Estado</th><th></th></tr></thead>
            <tbody>
              {bancos.map((b) => (
                <tr key={b.bancoId}>
                  <td data-label="Nombre">{b.nombre}</td>
                  <td data-label="Estado"><Badge bg={b.activo ? "success" : "secondary"}>{b.activo ? "Activo" : "Inactivo"}</Badge></td>
                  <td data-label="Acciones" className="text-end">
                    <Button size="sm" variant="outline-primary" className="me-1" onClick={() => abrir(b)}><i className="bi bi-pencil"></i></Button>
                    <Button size="sm" variant="outline-danger" onClick={() => setAEliminar(b)}><i className="bi bi-trash"></i></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton><Modal.Title style={{ fontSize: "1.1rem" }}>{editando ? "Editar banco" : "Nuevo banco"}</Modal.Title></Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required autoFocus />
            </Form.Group>
            <Form.Check type="switch" label="Activo" checked={form.activo} onChange={(e) => setForm({ ...form, activo: e.target.checked })} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
            <Button type="submit" variant="primary" disabled={guardando}>{guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <ModalConfirmar show={!!aEliminar} titulo="Desactivar banco" mensaje={`¿Desactivar "${aEliminar?.nombre}"?`}
        onConfirmar={confirmarEliminar} onCancelar={() => setAEliminar(null)} />
    </div>
  );
}
